import { render, staticRenderFns } from "./BRELAG_Shutter.vue?vue&type=template&id=46b49bf0&"
import script from "./BRELAG_Shutter.vue?vue&type=script&lang=js&"
export * from "./BRELAG_Shutter.vue?vue&type=script&lang=js&"
import style0 from "./BRELAG_Shutter.vue?vue&type=style&index=0&id=46b49bf0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports